module.exports = __webpack_public_path__ + "img/WP2023-SoMe-1200x1200.6a541140.png";